export default {
	// Function which gets the weeks in between two dates
	getWeeks (startDate, endDate) {
		// Get start date
		const start = new Date(startDate)
		// Get end date
		const end = new Date(endDate)
		// Add weeks until end date is reached
		var weeks = []
		var currentDate = start
		while (currentDate <= end) {
			weeks.push(this.getWeek(currentDate))
			currentDate = this.getNextMonday(currentDate)
		}
		return weeks
	},
	// Function which returns the current date falls within this week
	isCurrentWeek (week) {
		const currentWeek = this.getWeek(new Date())
		return (week.week === currentWeek.week && week.year === currentWeek.year)
	},
	// Function which returns the most recent monday from a given date
	getLastMonday (date) {
		var currentDate = new Date(date)
		currentDate = this.getCurrentMonday(currentDate)
		currentDate.setDate(currentDate.getDate() - 1)
		currentDate.setDate(currentDate.getDate() - (currentDate.getDay() + 6) % 7)
		return currentDate
	},
	// Function which returns which monday belongs to the week the given date falls in
	getCurrentMonday (date) {
		var currentDate = new Date(date)
		currentDate.setDate(currentDate.getDate() - (currentDate.getDay() + 6) % 7)
		return currentDate
	},
	// Function which returns the monday belonging to the day 7 days from given date
	getNextMonday (date) {
		var currentDate = new Date(date)
		currentDate.setDate(currentDate.getDate() + (7 - currentDate.getDay()) % 7 + 1)
		return currentDate
	},
	// Function which returns the name of the date's day (Monday, Tuesday, etc.)
	getDayName (date) {
		var day = new Date(date)
		return day.format('l')
	},
	getDayOfWeek (weekDate, dayName) {
		const day = new Date(weekDate)
		var increment = 0
		switch (dayName) {
		case 'tuesday':
			increment = 1
			break
		case 'wednesday':
			increment = 2
			break
		case 'thursday':
			increment = 3
			break
		case 'friday':
			increment = 4
			break
		case 'saturday':
			increment = 5
			break
		case 'sunday':
			increment = 6
			break
		}
		day.setDate(day.getDate() + increment)
		return day.format('Y-m-d')
	},
	// Function which returns the week before the one the given date falls in
	getLastWeek (date) {
		var currentDate = new Date(date)
		currentDate = this.getLastMonday(currentDate)
		return this.getWeek(currentDate)
	},
	// Function which returns the week after the one the given date falls in
	getNextWeek (date) {
		var currentDate = new Date(date)
		currentDate = this.getNextMonday(currentDate)
		return this.getWeek(currentDate)
	},
	// Returns a week object for the given date
	getWeek (date) {
		var currentDate = new Date(date)
		currentDate = this.getCurrentMonday(currentDate)
		const week = {
			date: currentDate,
			week: parseInt(currentDate.format('W')),
			year: parseInt(currentDate.format('Y')),
			end: this.getDayOfWeek(currentDate, 'sunday')
		}
		return week
	},
	getWeekDays (week) {
		var dayIndex = 0
		var weekDays = []
		while (dayIndex < 7) {
			var day = {}
			day.date = new Date(week.date)
			day.date.setDate(day.date.getDate() + dayIndex)
			day.number = day.date.format('d')
			day.string = day.date.format('Y-m-d')
			weekDays.push(day)
			dayIndex++
		}
		return weekDays
	},
	// Function which returns a month object for the given date (no half weeks)
	getMonth (date) {
		const monthIndex = this.getMonthIndex(date)
		var currentDate = date
		var currentMonthIndex = this.getMonthIndex(currentDate)
		var month = {}
		// Find first week
		while (currentMonthIndex === monthIndex) {
			const lastWeek = this.getLastWeek(currentDate)
			currentDate = lastWeek.date
			currentMonthIndex = this.getMonthIndex(currentDate)
		}
		month.start = this.getNextWeek(currentDate).date
		// Find last week
		currentDate = date
		currentMonthIndex = this.getMonthIndex(currentDate)
		while (currentMonthIndex === monthIndex) {
			const nextWeek = this.getNextWeek(currentDate)
			currentDate = nextWeek.date
			currentMonthIndex = this.getMonthIndex(currentDate)
		}
		month.end = this.getLastWeek(currentDate).date
		month.name = this.getMonthName(date)
		return month
	},
	getFullMonth (date) {
		var month = {}
		month.start = new Date(date.getFullYear(), date.getMonth(), 1)
		month.end = new Date(date.getFullYear(), date.getMonth() + 1, 0)
		month.name = date.format('F')
		month.index = date.getMonth()
		month.year = date.format('Y')
		return month
	},
	getMonthIndex (date) {
		var thursday = new Date(date)
		thursday.setDate(thursday.getDate() + 3)
		const monthIndex = parseInt(thursday.format('m'))
		return monthIndex
	},
	// Returns the name of the month the given date belongs to
	getMonthName (date) {
		var thursday = new Date(date)
		thursday.setDate(thursday.getDate() + 3)
		const monthName = thursday.format('F')
		return monthName
	},
	getTaskDays (tasks) {
		var taskDays = []
		tasks.forEach(function (task) {
			var dayExists = false
			taskDays.forEach(function (day) {
				if (task.Info.date === day) dayExists = true
			})
			if (!dayExists) taskDays.push(task.Info.date)
		})
		taskDays.sort(function (a, b) {
			return new Date(a) - new Date(b)
		})
		return taskDays
	},
	// Returns all the week objects associated with the given tasks
	getTaskWeeks (tasks) {
		var taskWeeks = []
		const service = this
		tasks.forEach(function (task) {
			const newWeek = service.getWeek(task.Info.date)
			var weekExists = false
			taskWeeks.forEach(function (week) {
				if (newWeek.week === week.week && newWeek.year === week.year) weekExists = true
			})
			if (!weekExists) taskWeeks.push(newWeek)
		})
		taskWeeks.sort(function (a, b) {
			return a.date - b.date
		})
		return taskWeeks
	},
	// Returns all the month objects associated with the given tasks
	getTaskMonths (tasks) {
		var taskWeeks = this.getTaskWeeks(tasks)
		var monthIndexes = []
		var monthDates = []
		var months = []
		const self = this
		taskWeeks.forEach(function (week) {
			const monthIndex = self.getMonthIndex(week.date)
			if (!monthIndexes.includes(monthIndex)) {
				monthIndexes.push(monthIndex)
				monthDates.push(week.date)
			}
		})
		monthDates.forEach(function (monthDate) {
			const month = self.getMonth(monthDate)
			months.push(month)
		})
		return months
	},
	formatPast (date) {
		const currentDate = new Date()
		const pastDate = new Date(date)
		const secondsAgo = (currentDate - pastDate) / 1000
		if (secondsAgo < 60 * 60) {
			const minutesAgo = Math.floor(secondsAgo / 60)
			return minutesAgo + ' minutes ago'
		} else if (secondsAgo < 60 * 60 * 24) {
			const hoursAgo = Math.floor(secondsAgo / (60 * 60))
			return hoursAgo + ' hours ago'
		} else if (secondsAgo < 60 * 60 * 24 * 30) {
			const daysAgo = Math.floor(secondsAgo / (60 * 60 * 24))
			return daysAgo + ' days ago'
		}
		return pastDate.format('d-m-Y')
	}
}
